import { ParsedUrlQuery } from 'querystring'

import { v4 as uuid4 } from 'uuid'

import { NodeIntentType } from 'interfaces/constants/subot'
import type { SubotMessage, SubotNodeIntent } from 'interfaces/types/Subot'

const queryKeysJson = [
  'form_submit_meta',
  'selected_actions',
  'current_selected',
  'current_keys',
  'current_polls',
]
const queryKeys = [
  'bot_id',
  'node_id',
  // 'account_id',
  'action_id',
  'action_value',
  'current_score',
  'gtm_id',
  'ga_client_id',
  'is_new',
  'title_url',
  'url',
  'window_id',
  ...queryKeysJson,
]
export const overrideParamsByQuery = (
  params: SubotMessage,
  query: ParsedUrlQuery,
) => {
  const keysSubotMessage = Object.keys(query) as (
    | keyof SubotMessage
    | 'source'
  )[]
  keysSubotMessage.map((key) => {
    const value = query[key] as string
    if (key === 'source') {
      params.is_new = value === 'first_login'
      return
    }
    if (!queryKeys.includes(key)) {
      return
    }

    /** Parse String to JSON */
    if (queryKeysJson.includes(key)) {
      try {
        params[key] = JSON.parse(value)
      } catch (error) {}
      return
    }

    /** Parse to number */
    if (key === 'account_id' || key === 'current_score' || key === 'bot_id') {
      params[key] = parseInt(value)
      return
    }

    /** Normal string */
    ;(params[key] as string) = value
  })
  return params
}

export const ssoIntents: (
  f: (props: { id?: string; defaultMessage?: string }) => string,
) => Array<SubotNodeIntent> = (f) => [
  {
    id: uuid4(),
    label: JSON.stringify({
      title: '',
      description: '',
    }),
    type: NodeIntentType.SSO_INTENT,
    url: '',
  },
  {
    id: uuid4(),
    label: JSON.stringify({
      title: f({
        id: 'subot.myHealth.title',
        defaultMessage: 'My Health',
      }),
      description: f({
        id: 'subot.myHealth.description',
        defaultMessage:
          'Personal identifiers (like your name) will always be removed to protect your privacy. ',
      }),
    }),
    type: NodeIntentType.SSO_INTENT,
    url: '/images/subot/my-health.svg',
  },
  {
    id: uuid4(),
    label: JSON.stringify({
      title: f({
        id: 'subot.saveData.title',
        defaultMessage: 'Save Data',
      }),
      description: f({
        id: 'subot.saveData.description',
        defaultMessage:
          'Hellobacsi would like to learn from your data to provide better healthcare for you',
      }),
    }),
    type: NodeIntentType.SSO_INTENT,
    url: '/images/subot/file-storage.svg',
  },
  {
    id: uuid4(),
    label: JSON.stringify({
      title: f({
        id: 'subot.productYourIdentifiers.title',
        defaultMessage: 'Protect your identifiers',
      }),
      description: f({
        id: 'subot.productYourIdentifiers.description',
        defaultMessage:
          'Personal identifiers (like your name) will always be removed to protect your privacy. ',
      }),
    }),
    type: NodeIntentType.SSO_INTENT,
    url: '/images/subot/shield.svg',
  },
]

export function checkUntilFinished(params: {
  condition: () => boolean
  finished: () => void
  timeout?: number
}) {
  const condition = params.condition
  const finished = params.finished
  const timeout = params.timeout || 3000

  const startTime = new Date().getTime()
  const intervalId = setInterval(() => {
    const endTime = new Date().getTime()
    if (endTime - startTime > timeout || condition()) {
      clearInterval(intervalId)
      finished()
    }
  }, 300)
}
